import { createRoute, redirect, type AnyRoute } from '@tanstack/react-router';
import { appRoute } from '../../router/parents';
import { AuditSettingsPage } from './audit';
import { BillingSettingsPage } from './billing';
import { BookingSettingsPage } from './booking';
import { FirmSettingsPage } from './firm';
import { IntegrationsSettingsPage } from './integrations';
import { SettingsLayout } from './layout';
import { MatterTypesSettingsPage } from './matter-types';
import { PaymentsSettingsPage } from './payments';
import { PrivacySettingsPage } from './privacy';
import { TeamSettingsPage } from './team';
import { TemplatesSettingsPage } from './templates';

/** /settings layout (section nav + outlet) with one child per section; /settings redirects to /settings/firm. */
const settingsRoute = createRoute({ getParentRoute: () => appRoute, path: '/settings', component: SettingsLayout });

const child = (path: string, component: () => JSX.Element) => createRoute({ getParentRoute: () => settingsRoute, path, component });

const settingsIndexRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/settings/firm' });
  },
});

export const settingsRoutes: AnyRoute[] = [
  settingsRoute.addChildren([
    settingsIndexRoute,
    child('firm', FirmSettingsPage),
    child('team', TeamSettingsPage),
    child('billing', BillingSettingsPage),
    child('matter-types', MatterTypesSettingsPage),
    child('templates', TemplatesSettingsPage),
    child('booking', BookingSettingsPage),
    child('payments', PaymentsSettingsPage),
    child('privacy', PrivacySettingsPage),
    child('integrations', IntegrationsSettingsPage),
    child('audit', AuditSettingsPage),
  ]),
];
